import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import CookieConsent from './CookieConsent';
import NavMenu from './NavMenu';
import './MainLayout.css';

interface Props {
  children: ReactNode;
}

export default function MainLayout({ children }: Props) {
  return (
    <div className="shack-site">
      <NavMenu />

      <main className="shack-main">{children}</main>

      <CookieConsent />

      <footer className="shack-footer">
        <div className="footer-wave">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path
              d="M0,60 C360,120 720,0 1080,60 C1260,90 1380,30 1440,60 L1440,120 L0,120 Z"
              fill="var(--tiki-dark)"
            />
          </svg>
        </div>
        <div className="footer-content">
          <div className="footer-brand">
            <img
              src="/images/Chuck's Mojito Shack.png"
              alt="Chuck's Mojito Shack"
              className="footer-logo"
            />
            <p className="footer-tagline">The Best Southern Mojitos in the World</p>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h4>Visit Us</h4>
              <p>
                Somewhere on the beach
                <br />
                South Florida, USA
              </p>
            </div>
            <div className="footer-col">
              <h4>Hours</h4>
              <p>
                Mon–Thu: 11am – 11pm
                <br />
                Fri–Sun: 11am – 1am
              </p>
            </div>
            <div className="footer-col">
              <h4>Follow the Vibe</h4>
              <div className="footer-social">
                <a href="#" title="Instagram" className="social-link">
                  &#x1F334;
                </a>
                <a href="#" title="Facebook" className="social-link">
                  &#x1F3DD;&#xFE0F;
                </a>
                <a href="#" title="TikTok" className="social-link">
                  &#x1F379;
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>
              &copy; {new Date().getFullYear()} Chuck's Mojito Shack. All rights reserved. Please
              drink responsibly.
            </p>
            <p>
              <Link to="/privacy" className="footer-legal-link">
                Privacy Policy
              </Link>{' '}
              &middot;{' '}
              <Link to="/trust" className="footer-legal-link">
                Trust Center
              </Link>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
